// extracted by mini-css-extract-plugin
module.exports = {"container":"YearNews_container__xizqt","content":"YearNews_content__q7c38","empty":"YearNews_empty__3SpeD","emptySty":"YearNews_emptySty__2nnI4"};